/**
 * Enum to strongly map between a friendly name and file name of the illustration
 */
export enum SpotName {
  Approved = 'approved',
  Avatar = 'avatar',
  Barcode = 'barcode',
  Calendar = 'calendar',
  Cartridge = 'cartridge',
  Celebrate = 'celebrate',
  ChatBubble = 'chat-bubble',
  CheckBox = 'check-box',
  CheckCircle = 'check-circle',
  Click = 'click',
  Cocktail = 'cocktail',
  Confirmation = 'confirmation',
  Connnect = 'connnect',
  Cookie = 'cookie',
  CreditCard = 'credit-card',
  Crm = 'crm',
  Cultivation = 'cultivation',
  Data = 'data',
  DeliveryCompleted = 'delivery-completed',
  Delivery = 'delivery',
  DigitalPayments = 'digital-payments',
  Discover = 'discover',
  Diversity = 'diversity',
  Drink = 'drink',
  Dolly = 'dolly',
  EasyReconciliations = 'easy-reconciliations',
  Efficiency = 'efficiency',
  Error = 'error',
  ExtendDate = 'extend-date',
  FinancialGrowth = 'financial-growth',
  FinancialInstitution = 'financial-institution',
  Focus = 'focus',
  FulfillmentIssues = 'fulfillment-issues',
  Growth = 'growth',
  Handshake = 'handshake',
  Hierarchy = 'hierarchy',
  Home = 'home',
  Laptop = 'laptop',
  Licenses = 'licenses',
  LightBulb = 'light-bulb',
  LightbulbError = 'lightbulb-error',
  LineChart = 'line-chart',
  Link = 'link',
  LocationPin = 'location-pin',
  Lock = 'lock',
  Messaging = 'messaging',
  Messages = 'messages',
  Microchip = 'microchip',
  MissingData = 'missing-data',
  MoneyTransfer = 'money-transfer',
  Money = 'money',
  NoInventoryAccess = 'no-inventory-access',
  NoInventory = 'no-inventory',
  NoPromote = 'no-promote',
  PackageReceived = 'package-received',
  Package = 'package',
  PaymentProcessing = 'payment-processing',
  Phone = 'phone',
  PieChart = 'pie-chart',
  ProductCycle = 'product-cycle',
  Puzzle = 'puzzle',
  Receipt = 'receipt',
  Retail = 'retail',
  SearchingDocument = 'searching-document',
  ShoppingBasket = 'shopping-basket',
  Shopping = 'shopping',
  Sign = 'sign',
  Smile = 'smile',
  Speed = 'speed',
  Time = 'time',
  Tools = 'tools',
  Truck = 'truck',
  User = 'user',
  Warehouse = 'warehouse',
  Warning = 'warning',
  XCircle = 'x-circle',
}

export type SpotNames = `${SpotName}`;

/**
 * String array of all illustration names
 */
export const spotNames = Object.values(SpotName);

export enum VignetteName {
  Api = 'api',
  Bank = 'bank',
  Basket = 'basket',
  BrandMenu = 'brand-menu',
  Calendar = 'calendar',
  Dashboard = 'dashboard',
  Deals = 'deals',
  DocumentSearch = 'document-search',
  Edit = 'edit',
  EmptyTray = 'empty-tray',
  Graph = 'graph',
  Integrations = 'integrations',
  LightBulb = 'light-bulb',
  Map = 'map',
  Megaphone = 'megaphone',
  Messages = 'messages',
  MoneyBank = 'money-bank',
  NoFiltersResult = 'no-filters-result',
  Notifications = 'notifications',
  OrdersEmpty = 'orders-empty',
  Payments = 'payments',
  PieChart = 'pie-chart',
  ProductCards = 'product-cards',
  ProductDetails = 'product-details',
  ProductDisplay = 'product-display',
  Search = 'search',
  SearchStorefront = 'search-storefront',
  Store = 'store',
  Todo = 'todo',
  Truck = 'truck',
  Users = 'users',
  Warehouse = 'warehouse',
  WarehouseDelivery = 'warehouse-delivery',
}

export type VignetteNames = `${VignetteName}`;

/**
 * String array of all vignette names
 */
export const vignetteNames = Object.values(VignetteName);

/**
 * Types of illustrations that map to the subfolder under ./assets/illustrations/<type>
 */
export enum IllustrationType {
  Spot = 'spot',
  Vignette = 'vignette',
  // Scene is not implemented, but adding it for future work mentioned in STASH-61.
  Scene = 'scene',
}

export type IllustrationTypes = `${IllustrationType}`;
